import app from '../app';

app.directive('cianAfUntouch', () => {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: (scope, element, attr, modelCtrl) => {
            element.on('focus', function () {
                modelCtrl.$setUntouched();
                scope.$apply(); // just note, dfsq pointed this out first
            });
        },
    };
});
